/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF("/Shoes/AnimSock.glb");
  const { actions } = useAnimations(animations, group);
  useEffect(() => {
    // AnimationAction[0].play()
    // actions.Animation.AnimationAction.play()
    actions.Animation.play();
    actions.Animation.repetitions = 1;
    actions.Animation.clampWhenFinished = true;
  }, [actions]);
  return (
    <group scale={1.2} ref={group} {...props} dispose={null}>
      <mesh
        name="sock"
        geometry={nodes.sock.geometry}
        material={materials["Material.004"]}
        position={[0.68, 2.04, 0.32]}
        rotation={[1.14, 0.38, -0.61]}
        scale={[0.21, 0.21, 0.21]}
      />
    </group>
  );
}

useGLTF.preload("/Shoes/AnimSock.glb");
